import { Header } from "antd/es/layout/layout";
import React from "react";
import HeaderNav from "./HeaderNav";

type Props = {};

const MainHeader = (props: Props) => {
  return (
    <Header className=" h-[8vh] bg-white">
      <div className=" container mx-auto flex justify-between items-center h-full">
        <div className=" flex flex-col items-start">
          <h1 className=" text-blue-500 font-bold text-xl p-0 m-0">Bet Gulf</h1>
          <span className=" m-0 p-0 text-xs text-gray-600">
            Powered By ULDASH NEXT
          </span>
        </div>
        <HeaderNav />
      </div>
    </Header>
  );
};

export default MainHeader;
